import React from 'react';
import { apiPost, startApiSession } from '../../services/apiClient';
import SupportQuestionModal from '../../modals/supportQuestionModal.jsx';
import RestorePasswordModal from '../../modals/restorePasswordModal.jsx';

export default class Login extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
			isCheckingSSO: true,
            busyCount: 0,
            login: "",
            password: "",
            error: null
        };

		if (this.props.location.state && this.props.location.state.ssoFailed) {
			this.state.isCheckingSSO = false;
		}
		
		this.supportQuestionModal = null;
		this.restorePasswordModal = null;
    }
	
	componentWillMount() {
		this.props.history.replace({
			pathname: '/login',
			state: {}
		});
    }

    componentDidMount() {
		if (this.state.isCheckingSSO) {
			checkSSO(e => this.applySsoState(e));
		}
	}

	applySsoState(isAvailable) {
		if (isAvailable) {
			redirectSSO();
		} else {
			this.setState({
				isCheckingSSO: false
			});
		}
	}

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

	sendQuestion() {
		if (this.supportQuestionModal) {
			this.supportQuestionModal.open();
		}
	}

	restorePassword() {
		if (this.restorePasswordModal) {
			this.restorePasswordModal.open();
		}
	}

    onLogin() {
        let data = {
            login: this.state.login,
            password: this.state.password
        };
        this.setState({ error: null });
        this.updateBusyCount(1);
        apiPost('auth/login', data)
            .then(response => {
                startApiSession(response.accessToken, response.refreshToken, true);
            })
            .catch(error => {
                this.updateBusyCount(-1);
                this.setState({ error: error});
            });
    }

    onLoginChange(e) {
        let login = e.target.value;
        this.setState({ login });
    }

    onPasswordChange(e) {
        let password = e.target.value;
        this.setState({ password });
    }

	onKeyUp(e) {
		if (e.keyCode === 13) {
			e.preventDefault();
			this.onLogin();
		}
	}

    render() {
        if (this.state.isCheckingSSO) {
            return (
                <div className="loading">
                    <img src="/img/spinner.gif" alt="loading" />
                </div>
            );
        } else {
			let isBusy = this.state.busyCount > 0;
			let errorMessage = null;
			let formGroupClasses = "form-group has-feedback";

			if (this.state.error) {
				errorMessage = (
					<span className="help-block">{this.state.error}</span>
				);
				formGroupClasses = formGroupClasses + " has-error";
			}

			return (
				<div className="login-box">
					<div className="login-logo">
						Мои Посылки
					</div>

					<div className="login-box-body">

						<p className="login-box-msg">Войдите для начала работы с посылками</p>

						<div className={formGroupClasses}>
							<input type="text" 
								className="form-control" 
								placeholder="Логин" 
								value={this.state.login}
								onChange={e => this.onLoginChange(e)} 
								onKeyUp={e => this.onKeyUp(e)}
								disabled={isBusy} 
							/>
							<span className="glyphicon glyphicon-user form-control-feedback"></span>
						</div>

						<div className={formGroupClasses}>
							<input type="password" 
								className="form-control" 
								placeholder="Пароль" 
								value={this.state.password}
								onChange={e => this.onPasswordChange(e)} 
								onKeyUp={e => this.onKeyUp(e)}
								disabled={isBusy} 
							/>
							<span className="glyphicon glyphicon-lock form-control-feedback"></span>
							{errorMessage}
						</div>

						<div className="row">
							<div className="col-xs-12 text-center">
								<button onClick={() => this.onLogin()} 
									className="btn btn-primary btn-flat" 
									disabled={isBusy}
								>
									Войти
								</button>
							</div>
						</div>

						<div className="row">
							<div className="col-xs-12 text-center">
								<button onClick={() => this.restorePassword()} 
									className="btn btn-link" 
									disabled={isBusy}
								>
									Восстановить пароль
								</button>
							</div>
						</div>

						<div className="row">
							<div className="col-xs-12 text-center">
								<button onClick={() => this.sendQuestion()} 
									className="btn btn-link" 
									disabled={isBusy}
								>
									Сообщить о проблеме
								</button>
							</div>
						</div>

					</div>

					<SupportQuestionModal ref={modal => this.supportQuestionModal = modal} />
					<RestorePasswordModal ref={modal => this.restorePasswordModal = modal} />
				</div>
			);
		}
    }
}


// WEBPACK FOOTER //
// ./App/pages/login/login.jsx